/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react';
import {concat, compact, get, map, find, set} from 'lodash';
import {I18n} from 'react-redux-i18n';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import formatOERLabel from '../../util/formatOERLabel';

const LOCAL_STORAGE_KEY = 'summaryCollapsableStorage';
const SUDDEN_STOP_KEY = 'sudden_stop';
const defaultSuddenStopClassificationBuckets = [
  {key: 'low'},
  {key: 'medium'},
  {key: 'high'}
];

export default class OerTypeSelector extends React.Component {
  constructor(props) {
    super(props);
    const {bucket: {key}} = props;
    const expanded = get(this.getStorage(), key, true);
    this.state = {
      expanded
    };
  }

  getStorage() {
    let saved = {};
    try {
      saved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    } catch (ignored) {
      saved = {};
    }
    if (!saved) saved = {};
    return saved;
  }

  getSubCategories = () => {
    const {bucket} = this.props;
    let subCategory = [];
    if (bucket.key === SUDDEN_STOP_KEY) {
      subCategory = concat(subCategory, this.getSuddenStopSubType());
    }
    subCategory = concat(subCategory, this.getSmartReviewCategories());
    if (compact(subCategory).length === 0) {
      return null;
    }

    return (
      <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {subCategory}
        </List>
      </Collapse>
    );
  }

  getSuddenStopSubType = () => {
    const {summary} = this.props;
    const classificationBuckets = get(summary, 'oerClassification.buckets');
    if (!classificationBuckets) return null;

    return map(defaultSuddenStopClassificationBuckets, type => {
      const docCount = get(find(classificationBuckets, it => it.key === type.key), 'doc_count', 0);
      return (
        <ListItem key={type.key} className="summarycolumn__oertype-item-sub" button onClick={this.handleSuddenStopFilterSelection(type.key)}>
          <ListItemText inset primary={`${I18n.t(`filter.oer.suddenstopsubtype.${type.key}`)}`} />
          <span className="summarycolumn__oertype-count">{docCount}</span>
        </ListItem>
      );
    });
  }

  getSmartReviewCategories = () => {
    const {bucket, customer} = this.props;
    const smartReview = get(bucket, 'smartReview.buckets', []);
    if (smartReview.length === 0 || !customer) {
      return null;
    }

    const intelliview = customer.data.intelliview || {enabled: false, eventTypes: [], secondaryVideos: []};
    const primaryDocCount = get(find(smartReview, {key_as_string: 'true'}), 'doc_count', 0) || 0;
    const secondaryDocCount = get(find(smartReview, {key_as_string: 'false'}), 'doc_count', 0) || 0;

    const isSecondaryVideoChecked = item => {
      return intelliview.secondaryVideos && intelliview.secondaryVideos.indexOf(item) !== -1;
    };
    return [
      intelliview.enabled ? (
        <ListItem
          key={`${bucket.key}-primary`}
          className="summarycolumn__oertype-item-sub"
          button
          onClick={this.handleSmartReviewFilterSelection(true)}
        >
          <ListItemText
            inset
            primary={I18n.t('filter.oer.smartReview.primary')}
          />
          <span className="summarycolumn__oertype-count">
            {primaryDocCount}
          </span>
        </ListItem>
      ) : null,

      intelliview.enabled && isSecondaryVideoChecked(bucket.key) ? (
        <ListItem key={`${bucket.key}-secondary`} className="summarycolumn__oertype-item-sub" button onClick={this.handleSmartReviewFilterSelection(false)}>
          <ListItemText inset primary={I18n.t('filter.oer.smartReview.secondary')} />
          <span className="summarycolumn__oertype-count">{secondaryDocCount}</span>
        </ListItem>
      ) : null];
  }

  handleSuddenStopFilterSelection = suddenstoptype => () => {
    this.handleOerFilterSelection(SUDDEN_STOP_KEY, {suddenstoptype})();
  }

  handleSmartReviewFilterSelection = primary => () => {
    const event = this.props.bucket.key;
    this.handleOerFilterSelection(event, {smartReview: {[event]: primary.toString()}})();
  }

  handleOerFilterSelection = (type, additionalFilters = {}) => () => {
    const {constrainedFilters} = this.props;
    this.props.applyFilter({
      ...additionalFilters,
      oerTypeFilter: [type],
      constrainedFilters
    });

    this.props.updateConstrainedFilters(constrainedFilters);
  }

  toggleExpand = () => {
    let saved = this.getStorage();
    saved = set(saved, this.props.bucket.key, !this.state.expanded);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(saved));

    this.setState({expanded: !this.state.expanded});
  }

  renderExpansionArrow = subCategory => {
    if (!subCategory) return null;
    if (this.state.expanded) {
      return <ExpandLess id={`collapseArrow_${this.props.bucket.key}`} onClick={this.toggleExpand} />;
    }

    return <ExpandMore id={`expandArrow_${this.props.bucket.key}`} onClick={this.toggleExpand} />;
  }

  render() {
    const {bucket} = this.props;
    const docCount = get(bucket, 'efetch.doc_count', bucket.doc_count, 0);
    const subCategory = this.getSubCategories();
    return (
      <React.Fragment>
        <ListItem className="summarycolumn__oertype-item" button>
          {this.renderExpansionArrow(subCategory)}
          <ListItemText
            onClick={this.handleOerFilterSelection(bucket.key)}
            primary={formatOERLabel(bucket.key)}
          />
          <span className="summarycolumn__oertype-count">{docCount}</span>
        </ListItem>
        {subCategory}
      </React.Fragment>
    );
  }
}
